import { render, staticRenderFns } from "./IMOClass.vue?vue&type=template&id=3ae5426a"
import script from "./IMOClass.vue?vue&type=script&lang=js"
export * from "./IMOClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports